/*
 * @Description: 
 * @Author: liangziyao
 * @Date: 2021-09-02 15:18:07
 */

/**
 * 活动时间
 * 6日15：00 ~ 12日23：59
 * 8:00-14:00、16:00-20:00
 */

const luckyArr = [{
  time: new Date('2021/8/6 15:00:00').getTime(),
  players: [{
    name: 'Morawyn8d',
    gift: '江湖大夢 - 江湖特級禮'
  },
  {
    name: 'Iveskmphn',
    gift: '破局：三國終章 - 沙場征戰禮'
  },
  {
    name: 'Harlan80sjr',
    gift: '斗羅大陸 - 99節幸運禮包'
  }]
}, {
  time: new Date('2021/8/6 15:28:00').getTime(),
  players: [{
    name: 'Iveskmphn',
    gift: '破局：三國終章 - 沙場征戰禮'
  },
  {
    name: 'Harlan80sjr',
    gift: '斗羅大陸 - 99節幸運禮包'
  },
  {
    name: 'Hortense2fqyz',
    gift: '創世破曉 - 99節超級禮包'
  }]
},
{
  time: new Date('2021/8/7 10:14:00').getTime(),
  players: [{
    name: 'Harlan80sjr',
    gift: '斗羅大陸 - 99節幸運禮包'
  },
  {
    name: 'Hortense2fqyz',
    gift: '創世破曉 - 99節超級禮包'
  },
  {
    name: 'Royalpx7',
    gift: '江湖大夢 - 九九節賀禮'
  }]
}, {
  time: new Date('2021/8/7 17:06:00').getTime(),
  players: [{
    name: 'Hortense2fqyz',
    gift: '創世破曉 - 99節超級禮包'
  },
  {
    name: 'Royalpx7',
    gift: '江湖大夢 - 九九節賀禮'
  },
  {
    name: 'Fannie99acy',
    gift: '創世破曉 - 99節驚喜禮包'
  }]
}, {
  time: new Date('2021/8/8 12:12:00').getTime(),
  players: [{
    name: 'Royalpx7',
    gift: '江湖大夢 - 九九節賀禮'
  },
  {
    name: 'Fannie99acy',
    gift: '創世破曉 - 99節驚喜禮包'
  },
  {
    name: 'Articulate5af20',
    gift: '叫我大掌櫃 - 99節富貴禮包'
  }]
}, {
  time: new Date('2021/8/8 19:28:00').getTime(),
  players: [{
    name: 'Fannie99acy',
    gift: '創世破曉 - 99節驚喜禮包'
  },
  {
    name: 'Articulate5af20',
    gift: '叫我大掌櫃 - 99節富貴禮包'
  },
  {
    name: 'Birdcps7w',
    gift: '斗羅大陸 - 99節幸運禮包'
  }]
}, {
  time: new Date('2021/8/9 9:56:00').getTime(),
  players: [{
    name: 'Articulate5af20',
    gift: '叫我大掌櫃 - 99節富貴禮包'
  },
  {
    name: 'Birdcps7w',
    gift: '斗羅大陸 - 99節幸運禮包'
  },
  {
    name: 'Ramseyfh0iv',
    gift: '破局：三國終章 - 沙場特級禮'
  }]
}, {
  time: new Date('2021/8/9 18:03:00').getTime(),
  players: [{
    name: 'Birdcps7w',
    gift: '斗羅大陸 - 99節幸運禮包'
  },
  {
    name: 'Ramseyfh0iv',
    gift: '破局：三國終章 - 沙場特級禮'
  },
  {
    name: 'Onehgkrw',
    gift: '江湖大夢 - 江湖特級禮'
  }]
}, {
  time: new Date('2021/8/10 13:11:00').getTime(),
  players: [{
    name: 'Ramseyfh0iv',
    gift: '破局：三國終章 - 沙場特級禮'
  },
  {
    name: 'Onehgkrw',
    gift: '江湖大夢 - 江湖特級禮'
  },
  {
    name: 'Happynmz96',
    gift: '叫我大掌櫃 - 99節富貴禮包'
  }]
}, {
  time: new Date('2021/8/10 16:23:00').getTime(),
  players: [{
    name: 'Onehgkrw',
    gift: '江湖大夢 - 江湖特級禮'
  },
  {
    name: 'Happynmz96',
    gift: '叫我大掌櫃 - 99節富貴禮包'
  },
  {
    name: 'Natalieav1ue',
    gift: '創世破曉 - 99節驚喜禮包'
  }]
}, {
  time: new Date('2021/8/11 11:37:00').getTime(),
  players: [{
    name: 'Happynmz96',
    gift: '叫我大掌櫃 - 99節富貴禮包'
  },
  {
    name: 'Natalieav1ue',
    gift: '創世破曉 - 99節驚喜禮包'
  },
  {
    name: '9digzzCunning',
    gift: '破局：三國終章 - 沙場征戰禮'
  }]
}, {
  time: new Date('2021/8/11 19:56:00').getTime(),
  players: [{
    name: 'Natalieav1ue',
    gift: '創世破曉 - 99節驚喜禮包'
  },
  {
    name: '9digzzCunning',
    gift: '破局：三國終章 - 沙場征戰禮'
  },
  {
    name: 'Deirdre3lskh',
    gift: '叫我大掌櫃 - 99節豪華禮包'
  }]
}, {
  time: new Date('2021/8/12 10:00:00').getTime(),
  players: [{
    name: '9digzzCunning',
    gift: '破局：三國終章 - 沙場征戰禮'
  },
  {
    name: 'Deirdre3lskh',
    gift: '叫我大掌櫃 - 99節豪華禮包'
  },
  {
    name: 'zmlNorman6g',
    gift: '創世破曉 - 99節超級禮包'
  }]
}, {
  time: new Date('2021/8/12 18:03:00').getTime(),
  players: [{
    name: 'Deirdre3lskh',
    gift: '叫我大掌櫃 - 99節豪華禮包'
  },
  {
    name: 'zmlNorman6g',
    gift: '創世破曉 - 99節超級禮包'
  },
  {
    name: 'Soldierx1',
    gift: '斗羅大陸 - 99節幸運禮包'
  }]
}]

export default function () {
  const START_TIME = new Date('2021/8/6 15:00:00');
  const END_TIME = new Date('2021/8/12 23:59:00');
  const CUR_TIME = new Date();

  if (!(CUR_TIME.getTime() > START_TIME.getTime())) {
    return [];
  }
  let players = [];
  for (let i = 0, length = luckyArr.length; i < length; i++) {
    if (luckyArr[i].time > CUR_TIME.getTime()) {
      break;
    }
    players = luckyArr[i].players;
  }
  return players;
}

